import styled from 'styled-components';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';

import { CarouselNavigationMotives, pickMotive } from './CarouselNavigation.motives';

export type StyledCarouselNavigationProps = {
  motive?: CarouselNavigationMotives;
};

const Container = styled.div<StyledCarouselNavigationProps>`
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  button span {
    margin: 0;
  }

  ${({ motive }) => motive && pickMotive(motive)};
`;

const NextButton = styled(Button)`
  position: absolute;

  z-index: 2;
`;

const PrevButton = styled(Button)`
  position: absolute;

  z-index: 2;
`;

const Label = styled(Headline)`
  margin: 0 1.2rem;
`;

export { Container, Label, PrevButton, NextButton };
